// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BulkUpload_browseStyle__k3pvW {
  font-family: "Montserrat" !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  line-height: 30px !important;
  letter-spacing: 0px !important;
  color: #000000 !important;
  justify-content: center !important;
}
.BulkUpload_titleHead__Ie2BM {
  font-family: "Montserrat" !important;
  font-size: 32px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  margin: 30px 0px !important;
}
.BulkUpload_clearForm__YfoCp {
  padding: 11px, 22px, 11px, 22px !important;
  border-radius: 6px !important;
  border: 1px solid #00ab55 !important ;
  font-family: "Montserrat" !important;
  color: #00ab55 !important;
  width: 277px !important;
  width: 85%;
  margin: 0 10% !important;
  height: 55px;
  background-color: white !important;
  font-weight: 700 !important;
  font-size: 15px !important;
  text-transform: none !important;
  box-shadow: none !important;
}
.BulkUpload_clearForm__YfoCp:disabled {
  border: 1px solid gray !important ;
  color: gray !important;
}
.BulkUpload_margin5__agIVS {
  padding: 10px !important;
}
.BulkUpload_note__NZN\\+k {
  font-family: "Montserrat" !important;
  width: 350px !important;
  text-align: center !important;
  margin-left: 90px !important;
  margin-top: 20px !important;
}
.BulkUpload_browseBtn__XG9GO {
  max-width: 192px !important;
  max-height: 48px !important;
  padding: 11px, 22px, 11px, 22px !important;
  border-radius: 6px !important;
  border: 1px solid #00ab55 !important;
  gap: 8px !important;
  color: #00ab55 !important;
  font-family: "Montserrat" !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  line-height: 26px !important;
  letter-spacing: 0px !important;
  justify-content: center !important;
}
.BulkUpload_browseBtn__XG9GO:disabled {
  color: gray !important;
  border: 1px solid gray !important;
  cursor: none;
}
.BulkUpload_saveBtn__LZRhi {
  width: 200px;
  text-transform: capitalize !important;
  font-family: "Montserrat" !important;
}

.BulkUpload_errormsg__4Q6z5 {
  font-family: "Montserrat" !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 24px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
  margin-top: 20px !important;
  margin-bottom: 10px !important;
}
.BulkUpload_fileTextSize__EbUah {
  font-size: 20px !important;
  font-weight: 600 !important;
}
.BulkUpload_text_left__occMm {
  text-align: left !important;
  font-family: "Montserrat" !important;
}
.BulkUpload_each_preview_policy__y4yKg {
  font-family: "Montserrat" !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  padding: 15px 0px;
  border-radius: 10px;
}
.BulkUpload_document_upload_logo__Tj8qP {
  flex: 0.1 1;
}
.BulkUpload_blue__bPd2R {
  color: #7c7c7c !important;
  font-family: "Montserrat" !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  line-height: 17.07px !important;
  text-align: left;
  max-width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 10px !important;
  display: block;
  margin-top: 10px !important;
}
.BulkUpload_link__i0kmi {
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  text-decoration: underline;
}
.BulkUpload_lastUpdate__8VKhc {
  background: #ffe4d5 !important;
  color: #000000 !important;
  border: 1px solid #d6f4f9 !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  width: 544px !important;
  font-family: "Montserrat" !important;
  font-weight: 400 !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  display: flex !important;
  height: max-content !important;
  line-height: 20px !important;
  padding: 10px !important;
  gap: 10px !important;
}
.BulkUpload_borderStyle__HObQR {
  border-radius: 8px !important;
  border-top: 3px solid #bb6f64 !important;
  border-right: 3px solid #bb6f64 !important;
  border-left: 3px solid #bb6f64 !important;
  border-bottom: 8px solid #bb6f64 !important;
  margin-top: 20px !important;
  width: 544px !important;
}
.BulkUpload_popup__0ydBk {
  background: #fff !important;
  color: #000000 !important;
  box-shadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px";
  border-radius: 12px !important;
  font-size: 14px !important;
  width: 85% !important;
  font-family: "Montserrat" !important;
  font-weight: 600 !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  display: flex !important;
  height: max-content !important;
  line-height: 20px !important;
  padding: 10px !important;
  gap: 10px !important;
}
.BulkUpload_buttonStyle__JzTjf {
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
  margin-left: auto !important;
  margin-right: 45px !important;
  margin-top: 50px !important;
  margin-bottom: 100px !important;
}
.BulkUpload_subHead__xxgan {
  font-family: "Montserrat" !important;
  font-size: 20px !important;
  font-weight: 600 !important;
  line-height: 24.38px !important;
  color: #000000 !important;
  margin-top: 30px !important;
  width: max-content !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/BulkUpload/BulkUpload.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,qCAAqC;EACrC,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,UAAU;EACV,wBAAwB;EACxB,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,0CAA0C;EAC1C,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,YAAY;EACZ,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAS;AACX;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;EAC7B,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,2CAA2C;EAC3C,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,uDAAuD;EACvD,8BAA8B;EAC9B,0BAA0B;EAC1B,qBAAqB;EACrB,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;EACxB,oBAAoB;AACtB;AACA;EACE,sCAAiC;EAAjC,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B","sourcesContent":[".browseStyle {\n  font-family: \"Montserrat\" !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  line-height: 30px !important;\n  letter-spacing: 0px !important;\n  color: #000000 !important;\n  justify-content: center !important;\n}\n.titleHead {\n  font-family: \"Montserrat\" !important;\n  font-size: 32px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  margin: 30px 0px !important;\n}\n.clearForm {\n  padding: 11px, 22px, 11px, 22px !important;\n  border-radius: 6px !important;\n  border: 1px solid #00ab55 !important ;\n  font-family: \"Montserrat\" !important;\n  color: #00ab55 !important;\n  width: 277px !important;\n  width: 85%;\n  margin: 0 10% !important;\n  height: 55px;\n  background-color: white !important;\n  font-weight: 700 !important;\n  font-size: 15px !important;\n  text-transform: none !important;\n  box-shadow: none !important;\n}\n.clearForm:disabled {\n  border: 1px solid gray !important ;\n  color: gray !important;\n}\n.margin5 {\n  padding: 10px !important;\n}\n.note {\n  font-family: \"Montserrat\" !important;\n  width: 350px !important;\n  text-align: center !important;\n  margin-left: 90px !important;\n  margin-top: 20px !important;\n}\n.browseBtn {\n  max-width: 192px !important;\n  max-height: 48px !important;\n  padding: 11px, 22px, 11px, 22px !important;\n  border-radius: 6px !important;\n  border: 1px solid #00ab55 !important;\n  gap: 8px !important;\n  color: #00ab55 !important;\n  font-family: \"Montserrat\" !important;\n  font-size: 15px !important;\n  font-weight: 700 !important;\n  line-height: 26px !important;\n  letter-spacing: 0px !important;\n  justify-content: center !important;\n}\n.browseBtn:disabled {\n  color: gray !important;\n  border: 1px solid gray !important;\n  cursor: none;\n}\n.saveBtn {\n  width: 200px;\n  text-transform: capitalize !important;\n  font-family: \"Montserrat\" !important;\n}\n\n.errormsg {\n  font-family: \"Montserrat\" !important;\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  line-height: 24px !important;\n  letter-spacing: 0px !important;\n  text-align: left !important;\n  margin-top: 20px !important;\n  margin-bottom: 10px !important;\n}\n.fileTextSize {\n  font-size: 20px !important;\n  font-weight: 600 !important;\n}\n.text_left {\n  text-align: left !important;\n  font-family: \"Montserrat\" !important;\n}\n.each_preview_policy {\n  font-family: \"Montserrat\" !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: auto;\n  padding: 15px 0px;\n  border-radius: 10px;\n}\n.document_upload_logo {\n  flex: 0.1;\n}\n.blue {\n  color: #7c7c7c !important;\n  font-family: \"Montserrat\" !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  line-height: 17.07px !important;\n  text-align: left;\n  max-width: 350px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding-left: 10px !important;\n  display: block;\n  margin-top: 10px !important;\n}\n.link {\n  max-width: 400px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  text-decoration: underline;\n}\n.lastUpdate {\n  background: #ffe4d5 !important;\n  color: #000000 !important;\n  border: 1px solid #d6f4f9 !important;\n  border-radius: 8px !important;\n  font-size: 14px !important;\n  width: 544px !important;\n  font-family: \"Montserrat\" !important;\n  font-weight: 400 !important;\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n  display: flex !important;\n  height: max-content !important;\n  line-height: 20px !important;\n  padding: 10px !important;\n  gap: 10px !important;\n}\n.borderStyle {\n  border-radius: 8px !important;\n  border-top: 3px solid #bb6f64 !important;\n  border-right: 3px solid #bb6f64 !important;\n  border-left: 3px solid #bb6f64 !important;\n  border-bottom: 8px solid #bb6f64 !important;\n  margin-top: 20px !important;\n  width: 544px !important;\n}\n.popup {\n  background: #fff !important;\n  color: #000000 !important;\n  box-shadow: \"rgba(100, 100, 111, 0.2) 0px 7px 29px 0px\";\n  border-radius: 12px !important;\n  font-size: 14px !important;\n  width: 85% !important;\n  font-family: \"Montserrat\" !important;\n  font-weight: 600 !important;\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n  display: flex !important;\n  height: max-content !important;\n  line-height: 20px !important;\n  padding: 10px !important;\n  gap: 10px !important;\n}\n.buttonStyle {\n  max-width: fit-content !important;\n  margin-left: auto !important;\n  margin-right: 45px !important;\n  margin-top: 50px !important;\n  margin-bottom: 100px !important;\n}\n.subHead {\n  font-family: \"Montserrat\" !important;\n  font-size: 20px !important;\n  font-weight: 600 !important;\n  line-height: 24.38px !important;\n  color: #000000 !important;\n  margin-top: 30px !important;\n  width: max-content !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"browseStyle": `BulkUpload_browseStyle__k3pvW`,
	"titleHead": `BulkUpload_titleHead__Ie2BM`,
	"clearForm": `BulkUpload_clearForm__YfoCp`,
	"margin5": `BulkUpload_margin5__agIVS`,
	"note": `BulkUpload_note__NZN+k`,
	"browseBtn": `BulkUpload_browseBtn__XG9GO`,
	"saveBtn": `BulkUpload_saveBtn__LZRhi`,
	"errormsg": `BulkUpload_errormsg__4Q6z5`,
	"fileTextSize": `BulkUpload_fileTextSize__EbUah`,
	"text_left": `BulkUpload_text_left__occMm`,
	"each_preview_policy": `BulkUpload_each_preview_policy__y4yKg`,
	"document_upload_logo": `BulkUpload_document_upload_logo__Tj8qP`,
	"blue": `BulkUpload_blue__bPd2R`,
	"link": `BulkUpload_link__i0kmi`,
	"lastUpdate": `BulkUpload_lastUpdate__8VKhc`,
	"borderStyle": `BulkUpload_borderStyle__HObQR`,
	"popup": `BulkUpload_popup__0ydBk`,
	"buttonStyle": `BulkUpload_buttonStyle__JzTjf`,
	"subHead": `BulkUpload_subHead__xxgan`
};
export default ___CSS_LOADER_EXPORT___;
